import React from 'react';
import { ChevronRight } from 'lucide-react';
import { IconTile } from './primitives';

const tileClass = 'text-left bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-card p-4';

/** Full-width tile for the tool people reach for most */
const FeaturedTile = ({ tool, accent, onAction }) => (
  <button
    onClick={() => { onAction?.(tool.action); }}
    className={`${tileClass} col-span-2 flex items-center gap-4`}
  >
    <IconTile icon={tool.icon} accent={accent} size="lg" />
    <div className="flex-1 min-w-0">
      <div className="font-semibold text-[15px] leading-tight text-gray-900 dark:text-white">{tool.title}</div>
      {tool.subtitle && <div className="text-xs text-gray-500 dark:text-gray-400 mt-1 leading-snug">{tool.subtitle}</div>}
    </div>
    <ChevronRight size={18} className="text-gray-300 dark:text-gray-600 flex-shrink-0" />
  </button>
);

/** Rotation tools: featured ones full-width on top, the rest two-up */
const ToolGrid = ({ tools, accent, onAction }) => (
  <div className="grid grid-cols-2 gap-3">
    {tools.filter((t) => t.featured).map((tool) => (
      <FeaturedTile key={tool.id} tool={tool} accent={accent} onAction={onAction} />
    ))}
    {tools.filter((t) => !t.featured).map((tool) => (
      <button
        key={tool.id}
        onClick={() => { onAction?.(tool.action); }}
        className={`${tileClass} flex flex-col gap-3 min-h-[7.5rem]`}
      >
        <div className="flex items-start justify-between">
          <IconTile icon={tool.icon} accent={accent} size="lg" />
          <ChevronRight size={16} className="text-gray-300 dark:text-gray-600 mt-1" />
        </div>
        <div>
          <div className="font-semibold text-[15px] leading-tight text-gray-900 dark:text-white">{tool.title}</div>
          {tool.subtitle && (
            <div className="text-xs text-gray-500 dark:text-gray-400 mt-1 leading-snug">{tool.subtitle}</div>
          )}
        </div>
      </button>
    ))}
  </div>
);

export default ToolGrid;
